<template>
  <div class="shows">
    <h1>Shows</h1>
    <div class="data">
      <div v-for="show in shows" :key="show.name" class="panel show" @click="open(show)">
        {{show.name}}
      </div>
    </div>
  </div>
</template>

<script>

import config from '../config';

export default {
  name: 'Shows',
  data() {
    return {
      shows: []
    }
  },
  methods: {
    open(show) {
      this.$router.push(`/seasons/${show.name}`)
    },
    getShows() {
      const password = localStorage.getItem('password');
      const authorization = localStorage.getItem('authorization');

      this.axios.get(`${config.api}/shows`, {
        headers: {
          password,
          authorization
        }
      })
      .then(result => {
        this.shows = result.data;
      })
    }
  },
  created() {
    this.getShows();
  }
}
</script>

<style scoped>

.show {
  width: 100px;
  height: 100px;

  transition: 200ms;

  transform: scale(1);

  cursor: pointer;

  margin: 5px;
}

.show:hover {
  transform: scale(1.1);
}

.data {
  display: flex;
  flex-wrap: wrap;
  margin: 50px 0 0 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Shows.vue